import axios from 'axios'
const GenreApi = {
    async getSingle(id) {
       const genre = await axios.get('/api/genre/' + id)
       return genre
    }
}

export default GenreApi